import { connectWithTranslations } from "../../../common/helpers/translationsHelpers";
import { SpeechScoreName, ScoreClasses } from "../../constants/speechScore";

const SpeechScore = ({
    speechScore,
    forceUpperCase = false,
    hideScoreNumber = false,
    translate,
}) => {
    const scoreLevel = speechScore.scoreLevel;
    const score = speechScore.score;
    const isScoreNaN = isNaN(score);

    const scoreLabel = SpeechScoreName[scoreLevel] ?? "NA";
    const cssClass = ScoreClasses[scoreLevel];

    const translatedScoreLabel =
        scoreLabel && forceUpperCase
            ? translate(scoreLabel).toUpperCase()
            : translate(scoreLabel);

    let formattedScore;

    if (!isScoreNaN) formattedScore = parseFloat(score).toFixed(1);

    return (
        <span className={`fxs_c_speech_score ${cssClass}`}>
            {translatedScoreLabel}
            {!hideScoreNumber && formattedScore && ` ${formattedScore}`}
        </span>
    );
};

export default connectWithTranslations()(SpeechScore);
